import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import { getCodeTaskBySlug } from '../../api/apis';
import { ICodeTask } from '../../lib/interfaces/CodeTask';
import CodeEditorLayoutWithFiles from '../Smart/CodeEditor/CodeEditorLayoutWithFiles';

const CodeEditorPageSaved: FC = () => {
	const { codeSlug = '' } = useParams();

	const { data } = useQuery<ICodeTask, Error>([`codeTask-${codeSlug}`], () =>
		getCodeTaskBySlug(codeSlug),
	);

	return (
		<div>
			{data?.code && (
				<div className="CodeEditorPage">
					<CodeEditorLayoutWithFiles
						field={data?.code}
						wrapperField={data}
						parentField=""
						taskSlug=""
						pageView
						backButton={false}
						taskId={null}
					/>
				</div>
			)}
		</div>
	);
};

export default CodeEditorPageSaved;
